query UserIsAuthenticatedQuery {
  userIsAuthenticated {
    ok
  }
}
